import { SubTypeField, JobStatus } from '@/enums';

export const SUB_TYPE_OPTIONS = [
    { label: 'Job (root)', value: SubTypeField.JOB_ROOT },
    { label: 'Job (child)', value: SubTypeField.JOB_CHILD },
    { label: 'Task (manu)', value: SubTypeField.TASK_MANUAL },
    { label: 'Task (auto)', value: SubTypeField.TASK_AUTOMATIC },
    { label: 'Task (oper)', value: SubTypeField.TASK_OPERATION },
];

export const STATUS_OPTIONS = [
    { label: 'Running', value: JobStatus.RUNNING },
    { label: 'Paused', value: JobStatus.PAUSED },
    { label: 'Complete', value: JobStatus.COMPLETED },
    { label: 'Error', value: JobStatus.ERRORED },
    { label: 'Canceled', value: JobStatus.CANCELED },
];
